import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import { USER_DETAILS_PATH } from 'commons-ui';
import UserDetails from './submodules/userDetails';
import UserRtfsList from './submodules/listUserRtfs';

const GetUserDetailsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getUserDetails]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}${USER_DETAILS_PATH}`}
				component={UserDetails}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].listUserRtfs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}${USER_DETAILS_PATH}/listUserRtfs`}
				component={UserRtfsList}
				exact
			/>
			<Redirect to={`${path}${USER_DETAILS_PATH}`} />
		</Switch>
	);
};

export default GetUserDetailsDashboard;
